/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { PatientPrescriptionItemRxFillStatus } from "./PatientPrescriptionItemRxFillStatus";
import type { PrescriptionPharmacy } from "./PrescriptionPharmacy";

export interface PatientPrescriptionItem {
  id: string;
  cursor: string;
  rxFillStatus?: PatientPrescriptionItemRxFillStatus;
  send_date?: string | null;
  rx_name?: string | null;
  pharmacy?: PrescriptionPharmacy | null;
  routing_method?: string | null;
}
